import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ConfigService, FormsUtilsService } from '../../../../../core';
import { ToastService } from '../../../../../domains/shared/components/toast/services/toast.service';
import { ConfigCliente } from '../../../../configuracoes/app/cliente';
import { Transportadora } from '../../../transportadora/transportadora';
import { transportadoraAtiva } from '../../../transportadora/transportadora-situacao';
import { IClienteLogistica } from '../../interfaces/cliente-logistica.interface';

@Component({
  selector: 'sgt-cliente-logistica-form',
  templateUrl: './cliente-logistica-form.component.html',
  styleUrls: ['./cliente-logistica-form.component.scss'],
})
export class ClienteLogisticaFormComponent implements OnInit {
  configCliente: ConfigCliente;
  transportadoraSituacaoAtiva = transportadoraAtiva;

  @Input() canEdit = true;
  @Input() entity: IClienteLogistica;

  @ViewChild('form') form: NgForm;

  constructor(
    private configService: ConfigService,
    private formsUtilsService: FormsUtilsService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.configCliente = this.configService.getCliente();
  }

  onChangeTransportadora(transportadora: Transportadora) {
    if (transportadora) {
      this.entity.idTransportadora = transportadora.id;
    } else {
      this.entity.idTransportadora = null;
    }
  }

  isValid(): boolean {
    this.formsUtilsService.makeAllFieldsDirty(this.form);

    if (this.entity.possuiRegraShelfLife && (this.entity.percShelfLife == null || this.entity.percShelfLife === undefined)) {
      this.toastService.warning('Informe o percentual mínimo de shelf life exigido pelo cliente');
      return false;
    }

    if (this.form.invalid) {
      this.toastService.warning('Para salvar é preciso informar corretamente todos os campos destacados em vermelho nos dados de logística');
      return false;
    }

    return true;
  }

  resolve() {
    if (!this.entity.possuiRegraShelfLife) {
      this.entity.percShelfLife = null;
    }
  }
}
